import { Component, OnInit } from '@angular/core';
import { QuoteCalcService, SERVICE_END_POINT, UtilService, DealPartnerFunctionalityService } from 'src/app/shared';
import { ActivatedRoute } from '@angular/router';
import { AppState } from 'src/app/store/state/app.state';
import { Store } from '@ngrx/store';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-product-quote-comparison',
  templateUrl: './product-quote-comparison.component.html',
  styleUrls: ['./product-quote-comparison.component.scss']
})
export class ProductQuoteComparisonComponent implements OnInit {
  public contentData;
  public titleString: string;
  public textString: string;
  public btnString: string;
  public btnFlag: boolean;
  public messageCode: number;
  public consentMessage: string;

  public quoteResult: any;
  public compDifference: number;
  public isLngIsBest: boolean;
  private comparatorValue: number;
  private annualIncome: number;
  private comparatorFlag: boolean = false;
  public displayWOMPanel: boolean = false;
  public padsRefNumber: string;
  private CMSData;
  constructor(private quoteCalcService: QuoteCalcService,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,  private utilService: UtilService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.productQuoteComparison;

    /**
     * Selecting the compQuote from the quoteResult JSON from the store.
     */
    store.select(STORE_VAL.quote_result).subscribe(response => {
      if (response.length > 0) {
        this.quoteResult = response[0]; // response[0];
      }
    });
    this.activatedRoute.data
    .subscribe((data) => {
      this.CMSData = data.cmsJson;
    });
  }
  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.setComparatorValues();
    this.getNotificationData();
    this.processMessageCode();
    this.getText();
  }

  agreeToAnnuity() {
    alert('You can\'t use this feature at the moment!!!');
  }

  getNotificationData() {
    this.titleString = this.contentData.titleString;
    this.btnString = this.contentData.btnString;
    this.btnFlag = this.contentData.btnFlag;
  }
  /**
   * Method to process the message code as per the difference from the
   * Comparator response
   */
  processMessageCode() {
    /**
     * L&G price is greater than OR equal to competitor
     * annualised Income (Best or at par case)
     */
    if (this.isLngIsBest) {
      this.messageCode = 1;
    } else if (!this.isLngIsBest && this.displayWOMPanel) {
      this.messageCode = this.quoteResult && DealPartnerFunctionalityService.isGARProduct(this.quoteResult['garIndicator']) ? 3 : 2;
    }
    /**
     * L&G price is lesser than the competitor
     * annualised Income (Worst case)
     */
    // tslint:disable-next-line:one-line
    else if (!this.isLngIsBest && !this.displayWOMPanel) {
      this.messageCode = 3;
    }
  }

  getText() {
    switch (this.messageCode) {
      case 1: this.textString = this.contentData.textString[0].messageText;
        break;
      case 2: this.textString = this.contentData.textString[1].messageText;
        break;
      case 3: this.textString = this.contentData.textString[2].messageText;
        break;
      default: this.textString = this.contentData.textString[0].messageText;
    }
  }

  setComparatorValues() {
    if (this.quoteResult.compQuote) {
      this.compDifference = Math.abs(this.quoteResult.compQuote.difference);
      this.comparatorValue = this.quoteResult.compQuote.comparatorValue;
      this.displayWOMPanel = this.quoteResult.compQuote.displayWOMPanelForDCJ ? true : false;
    }
    this.annualIncome = this.quoteResult.annualIncome ? this.quoteResult.annualIncome : 0;
    this.padsRefNumber = this.quoteResult.padsRefNo ? this.quoteResult.padsRefNo : '';
    // this.isLngIsBest = (this.quoteResult.compQuote >= 0) ? true : false; // Best Quote != LG; = Other
    this.isLngIsBest = (
      this.quoteResult.compQuote != null &&
      this.quoteResult.compQuote.bestQuote !== null &&
      this.quoteResult.compQuote.bestQuote === 'LG') ? true : false;
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.btnString = this.CMSData.string_TakeMeToAnnuityReadyCTALabel;
      this.contentData.titleString = this.CMSData.string_WholeOfMarketComparisonTitle;
      this.contentData.textString[0].messageText = this.CMSData.html_WholeOfMarketHighestWording;
      this.contentData.textString[1].messageText = this.CMSData.html_WholeOfMarketNotHighestWording1 + this.CMSData.html_WholeOfMarketNotHighestWording2;
      this.contentData.textString[2].messageText = this.CMSData.html_WholeOfMarketNotEligibleWording1 + this.CMSData.html_WholeOfMarketNotEligibleWording2;
      //this.userInputDetail['buttonConfig'].name = this.CMSData.commonBlock.string_NextCTALabel;
      this.textString = this.messageCode === 3 ? this.contentData.textString[2].messageText
        : (this.messageCode === 2 ? this.contentData.textString[1].messageText
          : this.contentData.textString[0].messageText);
      this.consentMessage = this.CMSData.string_NoAmsErrorMessage;    
    }
  }
  /** End of code block for CMS */
}





